<template>
  <div>
    <adding ref="add" />
    <modify ref="mod" />

    <template v-if="profiles !== null">
      <div class="row menubar">
        <button @click="$refs.add.profileCreate()" style="float:left;border-radius:0">
          <awesomeIcon icon="plus"/> Nieuw profiel
        </button>
      </div>

      <div class="card">
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Profielnaam</th>
              <th>Merk</th>
              <th>Gemiddeld jaarrendement</th>
              <th>Minimale horizon</th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="(profile, index) in slice(
              profiles,
              currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage)"
            :key="index"
          >
            <td width=50>{{profile.id}}</td>
            <td>{{ profile.name }}</td>
            <td>{{ profile.brand }}</td>
            <td>{{ profile.average_annual_return_rate }}%</td>
            <td>
              {{
                Number(profile.horizon_min) === 0 ? 'Geen' : `${profile.horizon_min}
                dag${Number(profile.horizon_min) !== 1 ? 'en' : '' }`
              }}
            </td>
            <td>
              <button
                class="secondary"
                @click="doAction('modifyUser', profile.id)"
              >
                <awesomeIcon icon="cog"/> Aanpassen
              </button>
              <button
                class="secondary"
                @click="doAction('deleteUser', profile.id)"
              >
                <awesomeIcon icon="times"/> Verwijder
              </button>
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="profiles.length"
          :resultsPerPage="resultsPerPage"
        />
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import { slice } from 'lodash-es';
import adding from './admin/addingProfile';
import modify from './admin/modifyProfile';

export default {
  name: 'AdminProfiles',
  components: {
    adding,
    modify,
  },
  data() {
    return {
      dropdownlist: [],
      profiles: null,
      currentPage: 0,
      resultsPerPage: 20,
    };
  },
  created() {
    this.getProfiles();
  },
  methods: {
    slice,
    doAction(action, profile) {
      if (action === 'modifyUser') {
        this.$refs.mod.profileModify(profile);
      } else if (action === 'deleteUser') {
        this.deleteProfile(profile);
      }
    },
    deleteProfile(profile) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u dit profiel wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteProfile(profile, (response) => {
              if (response.status === 200) {
                this.getProfiles();
              }
            });
          }
        },
      });
    },
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    getProfiles() {
      this.sdk.getProfiles((response) => {
        if (response.status === 200) {
          this.profiles = response.data;
          this.$nextTick(() => {
            this.resultsPerPage = 20;
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .secondary {
    padding: 0 10px;
    float: right;
  }

  .menubar, .card {
    border-radius: 0;
  }
</style>
